<script lang="ts">
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {getFormatter} from "../../utils";

    const formatter = getFormatter();
    export let data = {}
</script>

<div class="back-white radius p-1 m:p-ii mb-1">
    <div class="gItem">
        <div class="image back-gray" style="height: 50px">
            {#if data.icon === 'general'}
                <img height="50" width="50" src="{window['baseStatic']}pagos_app/pix/siniestros-generales.svg"
                     alt="Seguros generales">
            {:else if data.icon === 'vida'}
                <img height="50" width="50" src="{window['baseStatic']}pagos_app/pix/siniestros-vida.svg"
                     alt="Seguros vida">
            {:else if data.icon === 'vehiculos'}
                <img height="50" width="50" src="{window['baseStatic']}pagos_app/pix/siniestros-vehiculos.svg"
                     alt="Seguros vehículos">
            {/if}
        </div>
        <div class="info">
            <p style="font-weight: 600; font-size: .9rem">{data.productLabel}</p>
            <p style="font-weight: 600; font-size: .9rem">No. {data.productId}</p>
            {#if data.endoso}
                <p style="font-size:.9rem">Endoso: {data.endoso}</p>
            {/if}
        </div>
        <div class="payment">
            <div class="field border-bottom pb-i mb-ii">
                <small>No. Cuota</small>
                <div>{data.cuota}</div>
            </div>
            <div class="field border-bottom pb-i">
                <small>Fecha límite de pago</small>
                <div>{data.fechaLimite}</div>
            </div>
        </div>
        <div class="value pl-2 m:pl-0">
            <div class="field border-bottom">
                <small>Valor</small>
                <p><strong>{formatter(data.valor)}</strong></p>
            </div>
        </div>
<!--        <div class="icon">-->
<!--            <NauiButton icon="delete" color="accent" iconStyle="outlined" on:click/>-->
<!--        </div>-->
    </div>
</div>
<style>
    .gItem {
        display: grid;
        grid-gap: .5rem;
        grid-template-columns: 50px 200px 1fr 200px auto;
        grid-template-areas: 'image info payment value icon';
    }

    .border-bottom {
        border-bottom: 1px solid rgba(112, 112, 112, 0.1);
    }

    .field small {
        color: var(--text-gray);
        margin-bottom: .25rem;
        display: block;
    }

    .field {
        font-size: .9rem;
    }

    @media(min-width: 1024px){
        .gItem .value .field {
            border-bottom: none;
        }
    }

    @media (max-width: 1024px) {
        .gItem .image {
            grid-area: image;
        }

        .gItem .info {
            grid-area: info;
        }

        .gItem .payment {
            grid-area: payment;
        }

        .gItem .value {
            grid-area: value;
        }

        .gItem .icon {
            grid-area: icon;
        }

        .gItem {
            display: grid;
            grid-gap: .5rem;
            grid-template-columns: 50px 1fr auto;
            grid-template-areas: 'image info icon''image value value''image payment payment';
        }
    }

</style>